import React from 'react';
import { SvgIconProps } from '@mui/material';

export const JobsIconBig: React.FC<SvgIconProps> = (props) => (
    <svg
        width="93"
        height="100"
        viewBox="0 0 93 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M46.5 64.1176V52.8235M46.5 64.1176V75.4118M46.5 64.1176H79.875C86.0192 64.1176 91 59.0611 91 52.8235M46.5 64.1176H13.125C6.98083 64.1176 2 59.0611 2 52.8235M91 52.8235V86.7059C91 92.9434 86.0192 98 79.875 98H13.125C6.98083 98 2 92.9434 2 86.7059V52.8235M91 52.8235V47.1765M2 52.8235V30.2353C2 23.9977 6.98083 18.9412 13.125 18.9412H79.875C86.0192 18.9412 91 23.9977 91 30.2353M63.1875 18.9412V13.2941C63.1875 7.05655 58.2067 2 52.0625 2H40.9375C34.7933 2 29.8125 7.05655 29.8125 13.2941V18.9412"
            stroke="currentColor"
            strokeWidth="3.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default JobsIconBig;
